var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15C13.0875 15 12.7344 14.8531 12.4406 14.5594C12.1469 14.2656 12 13.9125 12 13.5V11.25C12 10.8375 12.1469 10.4844 12.4406 10.1906C12.7344 9.89688 13.0875 9.75 13.5 9.75C13.9125 9.75 14.2656 9.89688 14.5594 10.1906C14.8531 10.4844 15 10.8375 15 11.25V13.5C15 13.9125 14.8531 14.2656 14.5594 14.5594C14.2656 14.8531 13.9125 15 13.5 15ZM9 15C8.5875 15 8.23438 14.8531 7.94063 14.5594C7.64688 14.2656 7.5 13.9125 7.5 13.5V4.5C7.5 4.0875 7.64688 3.73438 7.94063 3.44063C8.23438 3.14687 8.5875 3 9 3C9.4125 3 9.76563 3.14687 10.0594 3.44063C10.3531 3.73438 10.5 4.0875 10.5 4.5V13.5C10.5 13.9125 10.3531 14.2656 10.0594 14.5594C9.76563 14.8531 9.4125 15 9 15ZM4.5 15C4.0875 15 3.73438 14.8531 3.44063 14.5594C3.14687 14.2656 3 13.9125 3 13.5V8.25C3 7.8375 3.14687 7.48438 3.44063 7.19063C3.73438 6.89688 4.0875 6.75 4.5 6.75C4.9125 6.75 5.26562 6.89688 5.55938 7.19063C5.85313 7.48438 6 7.8375 6 8.25V13.5C6 13.9125 5.85313 14.2656 5.55938 14.5594C5.26562 14.8531 4.9125 15 4.5 15Z",
    fill: "#4C4948"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar_chart.3329fef3ccef4b7a06d9777cf6568050.svg";
export { ForwardRef as ReactComponent };